import { useEffect, useState } from 'react';
// import PersonalInformation from "../PersonalInformation/PersonalInformation";
// import PaymentDetails from "../PaymentDetails/PaymentDetails";
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { Get, Post } from '../../api/client';
import FailedPaymentCard from '../../components/FailedPaymentCard/FailedPaymentCard';
import { ToastErrorStyles } from '../../constants/toastStyles';
import {
  closeLoader,
  openLoader,
} from '../../redux/actions/loader/loaderActions';
import { saveOrderDetails } from '../../redux/actions/orderDetails/orderDetailsActions';
import { openToastAndSetContent } from '../../redux/actions/toast/toastActions';
import PaymentOption from '../PaymentOption/PaymentOption';
import styles from './Checkouthome.module.scss';
import MerchantDetail from './MerchantDetail';

const CheckoutHome = () => {
  // const [paymentLinkDetails, setPaymentLinkDetails] = useState<any>();
  const [createOrderStatus, setCreateOrderStatus] = useState<any>({
    status: '',
    message: '',
  });
  const [fetchOrderDetailsStatus, setFetchOrderDetailsStatus] = useState<any>({
    status: '',
    message: '',
  });
  const dispatch = useDispatch();

  const body = queryString.parse(window.location.search);
  const ref = window.location.pathname.split('/')[1];

  const queryPayload = {
    customer: {
      firstName: body?.firstName,
      lastName: body?.lastName,
      mobile: body?.mobile,
      country: body?.country,
      email: body?.email,
    },
    order: {
      amount: body?.amount,
      reference: body?.reference,
      description: body?.description ?? 'checkout',
      currency: body?.currency,
    },
    Subsidiary: {
      SendCustomization: null,
    },
    payment: {
      redirectUrl: body?.redirectUrl,
      frequencyId: body?.frequencyId,
      numberOfPayment: body?.numberOfPayment,
      paymentLinkId: body?.paymentLinkId,
    },
  };

  const fetchOrderPayload = {
    reference: ref,
  };

  const CreateOrder = async () => {
    try {
      dispatch(openLoader());
      sessionStorage.setItem('checkout-payment-completed', '');
      const data: any = await Post('order/create', queryPayload);
      dispatch(saveOrderDetails(data?.data));
      setCreateOrderStatus({
        status: 'success',
        message: 'Order created successfully',
      });
    } catch (error: any) {
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        })
      );
      setCreateOrderStatus({
        status: 'failed',
        message: message,
      });
    } finally {
      dispatch(closeLoader());
    }
  };

  const fetchOrderDetails = async () => {
    try {
      dispatch(openLoader());
      sessionStorage.setItem('checkout-payment-completed', '');
      const data: any = await Post('order/status', fetchOrderPayload);
      dispatch(saveOrderDetails(data?.data));
      setFetchOrderDetailsStatus({
        status: 'success',
        message: 'Order fetched successfully',
      });
    } catch (error: any) {
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        })
      );
      setFetchOrderDetailsStatus({
        status: 'failed',
        message: message,
      });
    } finally {
      dispatch(closeLoader());
    }
  };

  const fetchPaymentLink = async () => {
    try {
      dispatch(openLoader());
      const ppload = { reference: body?.reference || ref };
      const res: any = await Post('paymentlink/get-keys/fetch', ppload, false);
      const data = res?.data?.data;
      sessionStorage.setItem('checkout_current_api_key', data?.publicKey);
      sessionStorage.setItem(
        'checkout_current_encryption_key',
        data?.publicEncryptionKey
      );
      queryPayload.order.reference = data.paymentReference;
      CreateOrder();
    } catch (error: any) {
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        })
      );
      setCreateOrderStatus({
        status: 'failed',
        message: message,
      });
    } finally {
      dispatch(closeLoader());
    }
  };

  const fetchPaymentLinkDetails = async () => {
    try {
      dispatch(openLoader());
      const ppload = { reference: body?.reference || ref };
      const res: any = await Post('paymentlink/get-keys/fetch', ppload, false);
      const result: any = await Get(`paymentlink/info?reference=${ref}`);
      const data = res?.data?.data;
      const details = result?.data?.data;
      sessionStorage.setItem('checkout_current_api_key', data?.publicKey);
      sessionStorage.setItem(
        'checkout_current_encryption_key',
        data?.publicEncryptionKey
      );

      queryPayload.order.amount = details?.paymentLink?.amount;
      queryPayload.order.reference = details?.paymentLink?.reference;
      queryPayload.order.description = details?.paymentLink?.description;
      queryPayload.order.currency = details?.paymentLink?.currency;

      queryPayload.customer.email = details?.subsidiary?.supportEmail;

      CreateOrder();
    } catch (error: any) {
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        })
      );
      setCreateOrderStatus({
        status: 'failed',
        message: message,
      });
    } finally {
      dispatch(closeLoader());
    }
  };

  // useEffect(() => {
  //   if (!!body?.encryptionKey === false) {
  //     fetchPaymentLink();
  //   } else {
  //     if (body.encryptionKey) {
  //       const encryptionKey = body.encryptionKey?.toString() ?? "";
  //       const apikey = body.apiKey?.toString() ?? "";
  //       sessionStorage.setItem("checkout_current_api_key", apikey);
  //       sessionStorage.setItem("checkout_current_encryption_key", encryptionKey);
  //       CreateOrder();
  //     }
  //   }
  // }, []);

  useEffect(() => {
    const pathname = window.location.pathname;
    const search = window.location.search;

    if (search) {
      const encryptionKey = body.encryptionKey?.toString() ?? '';
      const apiKey = body.apiKey?.toString() ?? '';

      if (!encryptionKey) {
        fetchPaymentLink();
      } else {
        sessionStorage.setItem('checkout_current_api_key', apiKey);
        sessionStorage.setItem(
          'checkout_current_encryption_key',
          encryptionKey
        );
        CreateOrder();
      }
    } else if (pathname && pathname !== '/') {
      const encryptionKey = body.encryptionKey?.toString() ?? '';

      if (!encryptionKey) {
        fetchPaymentLinkDetails();
      } else {
        sessionStorage.setItem(
          'checkout_current_encryption_key',
          encryptionKey
        );
        fetchOrderDetails();
      }
    }
  }, []);

  const ErrorBox = (
    <div className={styles.errorMessageBox}>
      <FailedPaymentCard
        message={createOrderStatus.message}
        paymentmethod="any"
      />
    </div>
  );
  return (
    <div className={styles.container}>
      <MerchantDetail />
      <div>
        {createOrderStatus.status === 'failed' ? ErrorBox : <PaymentOption />}
      </div>
    </div>
  );
};

export default CheckoutHome;
